import './styles/main.css';

import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { jwtDecode } from 'jwt-decode';
import { setUser } from './redux/userSlice';
import 'react-toastify/dist/ReactToastify.css';

import LoginPage from './pages/LoginPage';
import LandingPage from './pages/LandingPage';
import AdminUsersPage from './pages/AdminUsersPage';
import AdminStationPage from './pages/AdminStationPage';
import PrivateRoute from './components/PrivateRoute';
import { ToastContainer } from 'react-toastify';
import { initTheme } from "./helpers/theme";
import LogPage from "./pages/LogPage";


import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';



import { bootstrapAuth, getAccessToken } from './api_controll/apiClient';

function App() {
  const dispatch = useDispatch();
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const ok = await bootstrapAuth();

        if (ok) {
          const token = getAccessToken();
          if (token) {
            try {
              const decoded = jwtDecode(token);
              // payload z backendu: { sub, role, usr, ... }
              const userFromToken = {
                id: decoded.sub,
                username: decoded.usr,
                role_name: decoded.role,
              };
              dispatch(setUser(userFromToken));
            } catch (e) {
              console.error('Failed to decode access token:', e);
            }
          }
        }
      } finally {
        setAuthChecked(true);
      }
    })();
  }, [dispatch]);

  initTheme();

  if (!authChecked) {
    return <div>Loading...</div>;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />

        <Route
          path="/stations"
          element={
            <PrivateRoute>
              <LandingPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/adminUsers"
          element={
            <PrivateRoute allowedRoles={['Admin', 'Manager']}>
              <AdminUsersPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/adminStations"
          element={
            <PrivateRoute allowedRoles={['Admin', 'Manager']}>
              <AdminStationPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/emailLogs"
          element={
            <PrivateRoute allowedRoles={['Admin', 'Manager']}>
              <LogPage />
            </PrivateRoute>
          }
        />
      </Routes>

      <ToastContainer position="top-right" autoClose={3000} />
    </BrowserRouter>
  );
}

export default App;
